<template>
    <div class="is-fullheight">
        <section class="hero is-primary">
            <div class="hero-body">
                <div class="columns">
                    <div class="column is-12">
                        <div class="container content">
                            <i class="is-size-1 fas fa-code"></i>
                            <h1 class="title">vue-ui-table</h1>
                            <h3 class="subtitle">A flexible table component for Vue.js</h3>
                            <a href="https://github.com/davidegit/vue-ui-table" target="_blank" class="button is-link is-large is-light">
                                <span class="icon">
                                    <i class="fab fa-github"></i>
                                </span>
                                <span>Github</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="columns mx-0">
            <aside class="menu column is-2-fullhd is-3-desktop is-hidden-touch pt-2 pl-2">
                <affix relative-element-selector="#main-content" :offset="{ top: -10, bottom: 60 }">
                    <p class="menu-label">Guide</p>
                    <ul class="menu-list">
                        <li><a href="#install">Install</a></li>
                        <li><a href="#config-object">Config object</a></li>
                        <li>
                            <a href="#usage">Usage</a>
                            <ul>
                                <li><a href="#basic-usage">Basic</a></li>
                                <li>
                                    <a href="#header-prop">Customize header</a>
                                    <ul>
                                        <li><a href="#header-slot">Header slot</a></li>
                                        <li><a href="#headers-slot">Headers slot</a></li>
                                    </ul>
                                </li>
                                <li><a href="#style-props">Customize styles</a></li>
                                <li>
                                    <a href="#default-slot">Customize content</a>
                                    <ul>
                                        <li><a href="#row-slot">Row slot</a></li>
                                        <li><a href="#rows-slot">Rows slot</a></li>
                                    </ul>
                                </li>
                                <li><a href="#sorting">Sorting</a></li>
                                <li>
                                    <a href="#basic-pagination">Pagination</a>
                                    <ul>
                                        <li><a href="#pagination-object">Pagination object</a></li>
                                    </ul>
                                </li>
                                <li><a href="#remote-table">Remote table</a></li>
                            </ul>
                        </li>
                        <li class="back-to-top"><a href="#main-content">Back to top</a></li>
                    </ul>
                </affix>
            </aside>
            <main class="column is-8-fullhd is-9-desktop is-12-touch" id="main-content">
                <router-view/>
            </main>
        </div>
    </div>
</template>

<script>
    export default {
        name: "docs"
    }
</script>